import React from 'react';
import Select from '../Select/Select';

const options = [
  { value: 1, label: 'Facebook' },
  { value: 2, label: 'VK' },
  { value: 3, label: 'Instagram' },
  { value: 4, label: 'Telegram' },
];

const SelectSocialType = ({ ...props }) => {
  return <Select options={options} label={'Ð¡Ð¾Ñ.ÑÐµÑÑ'} placeholder={'ÐÑÐ±ÐµÑÐ¸ÑÐµ Ð¸Ð· ÑÐ¿Ð¸ÑÐºÐ°'} {...props} />;
};

export default SelectSocialType;
